// extracted by mini-css-extract-plugin
export default {"scatterplotgraph":"ScatterplotGraph_scatterplotgraph__A5+5r"};